// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Send = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Send = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Send = _exports.Send = function Send(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M16.6821 8.55951L7.16286 2.86618C4.89536 1.50951 2.33466 4.11366 3.72882 6.35866L5.52793 9.25534C5.57377 9.32867 5.65367 9.37367 5.74034 9.37367H10.8329C11.1746 9.37367 11.4579 9.657 11.4579 9.99867C11.4579 10.3403 11.1746 10.6237 10.8329 10.6237H5.73952C5.65286 10.6237 5.57295 10.6687 5.52712 10.742L3.72801 13.6387C2.33384 15.8837 4.89455 18.4878 7.16205 17.1312L16.6813 11.4378C17.7705 10.787 17.7704 9.21034 16.6821 8.55951Z",
      fill: "#212B36"
    }));
  };
});
